import React, { ReactNode } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { navigate } from "gatsby";

interface Auth0ProviderWithHistoryProps {
  children: ReactNode;
}

const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({
  children,
}) => {
  const domain = process.env.GATSBY_AUTH0_DOMAIN;
  const clientId = process.env.GATSBY_AUTH0_CLIENT_ID;
  const audience = process.env.GATSBY_AUTH0_AUDIENCE;

  // Handle the redirect callback
  const onRedirectCallback = (appState: any) => {
    // Use Gatsby's navigate function instead of window.history.pushState
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!domain || !clientId) {
    console.error("Auth0 domain and client ID must be provided");
    return <>{children}</>;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: typeof window !== "undefined" ? window.location.origin : "",
        ...(audience ? { audience } : {}),
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
      useRefreshTokensFallback
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
